export const FETCH_CUSTOM_PROFILE = 'cards/custom-profile/FETCH'
